import axios from "axios";
// import vueInstance  from '@/main.js'
import { baseURL, timeout, headers } from "@/config/index.js";
import { EventBus } from "./event-bus";
import { genAesKey, aesEncrypt, rsaEncrypt } from "@/utils/crypto";

// 后端给的 RSA 公钥（PEM）
let RSA_PUBLIC_KEY = null;

// 获取 RSA 公钥的函数
async function fetchRsaPublicKey() {
  if (RSA_PUBLIC_KEY) {
    return RSA_PUBLIC_KEY;
  }

  try {
    // 假设后端提供获取公钥的接口为 /api/public-key
    const response = await axios.get("/admin/api/public-key");
    RSA_PUBLIC_KEY = response.data;
    return RSA_PUBLIC_KEY;
  } catch (error) {
    console.error("获取 RSA 公钥失败:", error);
    throw error;
  }
}

//@ts-ignore
const request = axios.create({
  baseURL,
  timeout,
  headers,
});

// 添加请求拦截器
request.interceptors.request.use(
  async (config) => {
    // 确保获取到 RSA 公钥后再继续
    // await fetchRsaPublicKey();

    // 只对 GET/POST 的 params/data 加密，可按需调整
    // const raw = config.method === "get" ? config.params : config.data;
    // if (!raw) return config;

    // // 1. 随机产生 AES key
    // const aesKey = genAesKey();

    // // 2. 用 AES 加密业务参数
    // const cipherBody = aesEncrypt(raw, aesKey);

    // // 3. 用 RSA 公钥加密 AES key
    // const cipherKey = rsaEncrypt(aesKey, RSA_PUBLIC_KEY);

    // console.log(cipherBody, "cipherKey");

    // // 4. 把密文体和密文 key 放到 header，也可以放 body，按约定来
    // config.headers["X-Cipher-Key"] = encodeURIComponent(cipherKey);
    // config.headers["Content-Type"] = "application/json";
    // config.data = { cipher: cipherBody }; // 原参数清空，只保留密文
    // config.params = {};

    // 在发送请求之前做些什么
    // if (localStorage.getItem("cookies")) {
    //   config.headers["Cookie"] = localStorage.getItem("cookies");
    // }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    //对响应数据做点什么

    // 如果请求头包含 x-ignore-interceptor，则跳过拦截器逻辑
    // if (response.config.headers["x-ignore-interceptor"] === "true") {
    //   return response.data;
    // }

    const app_version = response.headers["x-app-version"];

    if (app_version) {
      if (localStorage.getItem("app_version") !== app_version) {
        localStorage.setItem("app_version", app_version);

        // 动态创建并挂载弹窗组件
        // 触发事件显示更新弹窗
        // Vue.prototype.$eventBus.$emit('showUpdateDialog', app_version);

        EventBus.$emit("showUpdateDialog", app_version);
      }
    }

    return response.data;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default request;
